import { Typography } from '@mui/material';
import { ExternalMatchRequestRule } from 'generated/graphql';
import React from 'react';
import { ConfidenceScoreOperator } from 'generated/graphql';

import { findCategoryByValueAndOperator } from 'utils/getConfidenceLevel';

type RuleDescriptionProps = Pick<
  ExternalMatchRequestRule,
  'confidenceScore' | 'minAmount' | 'maxAmount' | 'type'
> & {
  style?: React.CSSProperties;
};

export const RuleDescription: React.FC<RuleDescriptionProps> = ({
  confidenceScore,
  minAmount,
  maxAmount,
  type,
  style,
}) => {
  const hasConfidenceScore = confidenceScore?.operator && typeof confidenceScore.value === 'number';

  let confidenceScoreDisplay: string | null = null;

  if (hasConfidenceScore) {
    const numericValue =
      typeof confidenceScore.value === 'string'
        ? parseFloat(confidenceScore.value)
        : confidenceScore.value;

    const category = findCategoryByValueAndOperator(numericValue, confidenceScore.operator);

    const label = category ? category.label : confidenceScore.value;
    const operatorSymbol =
      confidenceScore.operator === ConfidenceScoreOperator.LessOrEqual ? '≤' : '≥';

    confidenceScoreDisplay = `${operatorSymbol} ${label}`;
  }

  const confidenceScorePart = hasConfidenceScore
    ? `with AI confidence score ${confidenceScoreDisplay}`
    : null;

  const parts = [
    `Auto-${type === 'approval' ? 'Approve' : 'Deny'} donations`,
    `between $${minAmount} and $${maxAmount}`,
    confidenceScorePart,
  ].filter(Boolean);

  return (
    <Typography variant="body1" fontSize="1rem" style={style}>
      {parts.join(' ')}
    </Typography>
  );
};

export default RuleDescription;
